import { useState } from 'react';
import { useMessageBox } from '../../../context/MessageBox';
import api from '../../../services/api';
import { handleErrorRequest } from '../../../utils/errorsValidation';

const NO_DATA_MESSAGE =
  'Sucessso na execução da solicitação, porém, não existe retorno com os parâmetro(s) solicitado(s).';

export const useInterestingEmails = () => {
  let emailsDataArr = [];
  const { setMessageData } = useMessageBox();
  const [emailsData, setEmailsData] = useState([]);
  const [checkedEmail, setCheckedEmail] = useState([]);
  const [isSending, setIsSending] = useState(false);
  const [anchId, setAnchorId] = useState('');

  const [confirmationBox, setConfirmationBox] = useState({
    show: false,
    type: '',
    callback: () => {},
  });

  const handleConfirmationBox = (type) => {
    if (checkedEmail.length === 0) {
      return;
    }
    setConfirmationBox({
      show: true,
      type,
      callback: sendApprove,
    });
  };

  const sendApprove = async () => {
    const objEmail = {
      ancoraId: anchId,
      listaEmailsInteresse: checkedEmail,
    };

    setIsSending(true);
    try {
      const endPoint = 'OperacoesAntecipacoes/EnviarEmailsInteresse';
      const response = await api.put(endPoint, objEmail);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        setCheckedEmail([]);
        await fetchEmails(objEmail.ancoraId);
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      handleErrorRequest(error.response);
    } finally {
      setIsSending(false);
    }
  };

  const handleCheckEmail = (fornecedorId, row) => {
    if (emailsDataArr?.find((el) => el.fornecedorId === fornecedorId)) {
      emailsDataArr = emailsDataArr.filter((el) => el.fornecedorId !== fornecedorId);
      setCheckedEmail(emailsDataArr);
    } else {
      emailsDataArr.push({
        ancoraId: row.ancoraId,
        fornecedorId: fornecedorId,
        liberado: true,
      });
      setCheckedEmail(emailsDataArr);
    }
  };

  const fetchEmails = async (anchorId) => {
    setEmailsData([]);
    setAnchorId(anchorId);
    setIsSending(true);
    try {
      const endPoint = `OperacoesAntecipacoes/ConsultarEmailsInteresse?ancoraId=${anchorId}`;
      const response = await api.get(endPoint);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        if (response.data.resposta[0].message !== NO_DATA_MESSAGE) {
          setEmailsData(response.data.resposta);
        } else {
          setEmailsData([]);
        }
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      handleErrorRequest(error.response);
    }
    setIsSending(false);
  };

  return {
    confirmationBox,
    emailsData,
    fetchEmails,
    handleCheckEmail,
    handleConfirmationBox,
    isSending,
    sendApprove,
    setConfirmationBox,
  };
};
